export const baseImg = "https://sisccltd.com/medialgeria/";
